
import StaticPage from "../components/StaticPage";
export default {
    components: {StaticPage},
    async asyncData({ $axios, route, error }) {
        try {
            const res = await $axios.get('api/v1/static-pages/' + route.name);

            return {
                page: res.data.data,
            }
        }
        catch (e) {
            error({ statusCode: 404, message: 'Page not found' });
        }
    },
    head() {
        return {
            title: this.page.seo_title ? this.page.seo_title : this.page.name,
            meta: [
                { hid: 'description', name: 'description', content: this.page.seo_description },
                { hid: 'keywords', name: 'keywords', content: '' },
            ]
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
}
